<template>
  <div id="filter">
    <div class="item-category" v-if="type=='category'">
      <b-row>
        <b-col>
          <b-form-group label="제품 종류">
            <b-form-select 
              size="sm" 
              text-field="name"
              value-field="_id"
              v-model="category_id"
              :options="category_list"
              @change="categoryChange"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="영양성분">
            <b-form-radio-group
              v-model="nutri_id"
            >
              <b-form-radio 
                v-for="nutri in nutri_list"
                :key="nutri._id"
                :value="nutri._id"
                @change="nutriChange"
              >
                {{nutri.name}}
                <b-badge variant="danger" v-if="nutri.core">핵심성분</b-badge>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="item-nutrition" v-if="type=='nutri'">
      <b-row>
        <b-col>
          <b-form-group label="영양소 종류">
            <b-form-select 
              size="sm" 
              text-field="name"
              value-field="_id"
              v-model="nutri_id"
              :options="nutri_list"
              @change="nutriChange"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div class="search-nutrition" v-if="type=='search'">
      <b-row>
        <b-col>
          <b-form-group>
            <div slot="label">
              영양 성분
              <a class="float-right" v-if="nutri_list.length > 5" @click="toggleNutris">{{nutrisFull?'닫기':'전체보기'}}</a>
            </div>
            <b-form-radio-group
              v-model="nutri_id"
            >
              <b-form-radio 
                v-for="nutri in nutrisToShow"
                :key="nutri._id"
                :value="nutri._id"
                @change="nutriChange"
              >
                {{nutri.name}}
                <b-badge variant="danger" v-if="nutri.core">핵심성분</b-badge>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div v-show="isMobile" @click="toggleFilter" class="align-right button-icon button-filter">
      <span v-show="!filterOpen"><b-icon-filter />검색필터</span>
      <b-icon-x v-show="filterOpen"/>
    </div>
    <b-row>
      <transition name='filter'>
        <b-col id="filter-div" :class="`filter-${isMobile?'mobile':'full'}`" v-show="!isMobile || filterOpen">        
          <div class="filter-detail">
            <b-row align-v="start">
              <b-col>
                <b-form-group label="형태" v-show="type_list.length>0">
                  <b-form-checkbox-group
                    v-model="types"
                    :options="type_list"
                    @change="change('types', $event)"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="특징">
                  <b-form-checkbox-group
                    v-model="features"
                    :options="feature_list"
                    @change="change('features', $event)"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="판매처">
                  <b-form-checkbox-group
                    v-model="mall_types"
                    :options="mall_list"
                    @change="change('mall_types', $event)"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="start">
              <b-col>
                <b-form-group v-show="brand_list.length>0">
                  <div slot="label">
                    브랜드
                    <a class="float-right" @click="toggleBrands">{{brandsFull?'닫기':'전체보기'}}</a>
                  </div>
                  <b-form-checkbox-group
                    v-model="brands"
                    value-field="_id"
                    text-field="name"
                    @change="change('brands', $event)"
                    :options="brandsToShow"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="start">
              <b-col>
                <b-form-group>
                  <b-form-checkbox v-model="with_ship" switch @change="change('with_ship', $event)">
                    배송비 {{with_ship?'포함':'미포함'}}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group :label="'수량: '+ amountText">
                  <b-form-input type=range min=0 max=5 v-model="amount" @change="change('amount', $event)" />
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </transition>
    </b-row>
  </div>
</template>

<script>
import {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter, BIconListOl
} from 'bootstrap-vue'
import { mapGetters, mapState } from 'vuex'
import { mapSetters } from '../store/util'

var filterKeys = ['brands', 'types', 'features', 'mall_types', 'with_ship', 'amount']

export default {
  name: 'FilterComponent',
  components: {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter
  },
  props: {
    type: {type: String, default: 'category'},
  },
  data () {
    return {
      brandsFull: false,
      nutrisFull: false,
      filterOpen: false,
    }
  },
  computed: {
    ...mapState({
      category_list: state => state.category.list,
      nutri_list: state => state.nutri.list,
      brand_list: state => state.brand.list,
      type_list: state => state.type_list,
      feature_list: state => state.feature_list,
      mall_list: state => state.mall_list,
    }),
    ...mapSetters(
      mapState({
        category_id: state => state.filter.category_id,
        nutri_id: state => state.filter.nutri_id
      }),
      {
        category_id(value) {},
        nutri_id(value) {}
      }
    ),
    ...mapSetters(
      mapState('filter', filterKeys),
      filterKeys.reduce((setters, key) => {
        setters[key] = () => {}
        return setters
      }, {})
    ),
    ...mapGetters('filter', {
      amountText: 'amountText'
    }),
    isMobile () {
      return this.$store.state.isMobile
    },
    brandsToShow () {
      if (this.brandsFull) {
        return this.brand_list
      }
      else {
        return this.brand_list.slice(0, 5)
      }
    },
    nutrisToShow () {
      if (this.nutrisFull) {
        return this.nutri_list
      }
      else {
        return this.nutri_list.slice(0, 5)
      }
    }
  },
  created() {
  },
  methods: {
    toggleBrands () {
      this.brandsFull = !this.brandsFull
    },
    toggleNutris () {
      this.nutrisFull = !this.nutrisFull
    },
    toggleFilter() {
      this.filterOpen = !this.filterOpen
    },
    categoryChange (value) {
      let query = this.$route.query
      this.$router.push({path: `/items/${value}`, query: {}})
    },
    nutriChange (value) {
      if (this.type == 'nutri') {
        let path = this.$route.path
        let query = this.$route.query
        this.$router.push({path: `/nutri/${value}`, query: {}})
      }
      else {
        this.change('nutri_id', value)
      }
    },
    change (key, value) {
      let path = this.$route.path
      let params = this.$route.params
      let query = Object.assign({}, this.$route.query)
      if (key.endsWith('s')) {
        if (value.length == 0) {
          delete query[key]
        }
        else {
          query[key] = value.join(',')
        }
      }
      else {
        query[key] = String(value)
      }
      this.$router.push({path, params, query}).catch(err => {})
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  .td-rank {
    width: 10vw;
  }
  .td-name {
    width: 45vw !important;
  }
  .td-norm-amount {
    width: 25vw;
  }
  .empty-text {
    text-align: left !important;
  }
  .spinner-wrapper {
    text-align: left !important;
  }
}

/* .filter-enter-active,
.filter-leave-active
{
  transition: transform 0.5s ease;
}

.filter-enter,
.filter-leave-to {
  transform: translateY(-100%);
  transition: all 0.5s ease-in 0s
} */
</style>


// WEBPACK FOOTER //
// src/components/Filter.vue